document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".content-hub-faq button");

  function toggleFaq(item) {
    const wasExpanded = item.getAttribute("aria-expanded") === "true";

    if (wasExpanded) {
      item.setAttribute("aria-expanded", "false");
      return;
    }

    for (let i = 0; i < items.length; i++) {
      items[i].setAttribute("aria-expanded", "false");
    }
    item.setAttribute("aria-expanded", "true");
  }

  items.forEach((item) =>
    item.addEventListener("click", () => toggleFaq(item))
  );
});
